"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withMetaSnippet = exports.FieldType = void 0;

var react_1 = __importDefault(require("react"));

var uuid_1 = require("uuid");

var core_1 = require("@bodiless/core");

var fclasses_1 = require("@bodiless/fclasses");

var FieldType;

(function (FieldType) {
  FieldType["Text"] = "text";
  FieldType["TextArea"] = "textarea";
})(FieldType = exports.FieldType || (exports.FieldType = {}));

exports.withMetaSnippet = function (options) {
  return core_1.withEditFormSnippet({
    renderForm: function renderForm(_a) {
      var formApi = _a.formApi;
      var name = options.name,
          label = options.label,
          placeholder = options.placeholder,
          useFormElement = options.useFormElement;

      var _b = core_1.useMenuOptionUI(),
          ComponentFormLabel = _b.ComponentFormLabel,
          ComponentFormText = _b.ComponentFormText;

      var Field = useFormElement ? useFormElement() : ComponentFormText;
      return react_1.default.createElement(fclasses_1.Div, {
        key: name
      }, react_1.default.createElement(ComponentFormLabel, null, label), react_1.default.createElement(Field, {
        field: name,
        placeholder: placeholder,
        formapi: formApi
      }));
    },
    submitValueHandler: function submitValueHandler(values) {
      var name = options.name,
          nextSubmitHandler = options.submitHandler;
      var submitValues = {
        content: values[name]
      };
      return nextSubmitHandler ? nextSubmitHandler(submitValues) : submitValues;
    },
    initialValueHandler: function initialValueHandler(values) {
      var _a;

      var name = options.name,
          nextInitialValuesHandler = options.initalValueHandler;
      var initialValues = (_a = {}, _a[name] = values.content, _a);
      return nextInitialValuesHandler ? nextInitialValuesHandler(initialValues) : initialValues;
    }
  });
};

var withMetaFormHeader = function withMetaFormHeader(headerProps) {
  return function (Component) {
    var metaHeaderSnippet = {
      id: uuid_1.v1(),
      render: function render() {
        if (!headerProps) return react_1.default.createElement(react_1.default.Fragment, null);

        var _a = core_1.useMenuOptionUI(),
            ComponentFormTitle = _a.ComponentFormTitle,
            ComponentFormDescription = _a.ComponentFormDescription;

        return react_1.default.createElement(fclasses_1.Div, {
          key: "form-header"
        }, react_1.default.createElement(ComponentFormTitle, null, headerProps.title), react_1.default.createElement(ComponentFormDescription, null, headerProps.description));
      }
    };

    var WithFormHeader = function WithFormHeader(props) {
      core_1.useRegisterSnippet(metaHeaderSnippet);
      return react_1.default.createElement(Component, __assign({}, props));
    };

    return WithFormHeader;
  };
};

var defaultMetaFormHeader = {
  title: 'SEO Data Management',
  description: "Enter the page level data used for SEO. \n  This is metadata needed for SEO that will go in the page header."
};

var withMetaForm = function withMetaForm(useMenuOptions, metaFormHeader) {
  return core_1.ifEditable(core_1.withCompoundForm({
    useMenuOptions: useMenuOptions,
    name: 'Meta',
    peer: true
  }), withMetaFormHeader(metaFormHeader || defaultMetaFormHeader));
};

exports.default = withMetaForm;